import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change as changeFieldValue, reduxForm } from 'redux-form';
import Moment from 'react-moment';
import selecionaManutencaoVeiculo from '../../actions/manutencao-veiculo/seleciona-manutencao-veiculo';
import moment from 'moment'
import DetalhesManutencaoVeiculo from './DetalhesManutencaoVeiculo';
import alterarExibicaoDetalhamentoManutencaoVeiculo from '../../actions/manutencao-veiculo/alterarExibicaoDetalhamentoManutencaoVeiculo';
import Autorizacao from '../../security/Autorizacao';
import { PERFIL_ADMIN, getAdminEmpresa, getOperadorEmpresa, getGestorOperacoes } from '../../security/securityContext';
import { formatarReal } from '../../util/numberUtil';

export class ManutencaoVeiculo extends Component {

    exibirIcone () {
        if (this.props.manutencaoVeiculo.exibirDetalhe) {
            return <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicaoDetalhamentoManutencaoVeiculo(this.props.manutencaoVeiculo)}>
            &#xE5C7;</i>
        }
        return <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicaoDetalhamentoManutencaoVeiculo(this.props.manutencaoVeiculo)}>&#xE5C5;</i>
    }

    selecionaManutencaoVeiculo() {
        this.props.changeFieldValue('formularioPainelRegistroManutencaoVeiculo', 'tipoOcorrencia', this.props.manutencaoVeiculo.tipoOcorrencia);
        this.props.changeFieldValue('formularioPainelRegistroManutencaoVeiculo', 'ocorrencia', this.props.manutencaoVeiculo.ocorrencia);        
        this.props.changeFieldValue('formularioPainelRegistroManutencaoVeiculo', 'valorTotalGasto', this.props.manutencaoVeiculo.valorTotalGasto);

        this.props.selecionarDataOcorrencia(moment(this.props.manutencaoVeiculo.dataOcorrencia).toDate());
        this.props.selecionaManutencaoVeiculo(this.props.manutencaoVeiculo);
    }

    limparSelecaoManutencaoVeiculo() {
        this.props.limparSelecaoManutencaoVeiculo();
    }

    render() {
        const { manutencaoVeiculo } = this.props;
        return (
            <div className="vx-row-item" style={manutencaoVeiculo.selecionado ? { borderLeft: '3px solid #FF6A00' } : {}}>
                <div className="vx-row-item-inner vx-row-item-inner--manutencao-veiculo">
                    <div className="vx-row-cell">
                        <button className="vx-row-expand-btn"
                            onClick={() => this.props.alterarExibicaoDetalhamentoManutencaoVeiculo(manutencaoVeiculo)}>
                            <span className="material-icons">{manutencaoVeiculo.exibirDetalhe ? 'expand_less' : 'expand_more'}</span>
                        </button>
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Data Ocorrência</span>
                        <Moment format="DD/MM/YYYY">{manutencaoVeiculo.dataOcorrencia}</Moment>
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Registrado Por</span>
                        {manutencaoVeiculo.registradoPor}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Data Entrada</span>
                        <Moment format="DD/MM/YYYY">{manutencaoVeiculo.dataCadastro}</Moment>
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Tipo Ocorrência</span>
                        {manutencaoVeiculo.tipoOcorrencia}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Valor Total</span>
                        {manutencaoVeiculo.valorTotalGasto ? formatarReal(manutencaoVeiculo.valorTotalGasto) : '—'}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Ações</span>
                        <Autorizacao
                            perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                                getGestorOperacoes(this.props.empresaSelecionada.id),
                                getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                            <div style={{ display: 'flex', gap: 4 }}>
                                <button type="button" className="vx-act-btn vx-act-btn--delete"
                                        title="Excluir"
                                        data-toggle="modal"
                                        data-target="#modalConfirmacaoExclusaoManutencaoVeiculo"
                                        onClick={() => this.props.selecionaManutencaoVeiculo(manutencaoVeiculo)}>
                                    <span className="material-icons">delete</span>
                                </button>
                                <button type="button" className="vx-act-btn vx-act-btn--edit"
                                        title="Editar"
                                        onClick={() => {
                                            if (manutencaoVeiculo.selecionado) {
                                                this.limparSelecaoManutencaoVeiculo();
                                            } else {
                                                this.selecionaManutencaoVeiculo(manutencaoVeiculo);
                                            }
                                        }}>
                                    <span className="material-icons">edit</span>
                                </button>
                            </div>
                        </Autorizacao>
                    </div>
                </div>
                <DetalhesManutencaoVeiculo manutencaoVeiculo={manutencaoVeiculo}/>
            </div>
        )
    }
}

export const mapStateToProps = state => (
    {
        empresaSelecionada: state.empresaSelecionada,
        manutencaoVeiculoSelecionado: state.manutencoesVeiculo.manutencaoVeiculoSelecionado        
    });

export default connect(mapStateToProps, {
    changeFieldValue,
    selecionaManutencaoVeiculo,
    alterarExibicaoDetalhamentoManutencaoVeiculo
})(reduxForm({
    form: 'formularioPainelRegistroManutencaoVeiculo'
})(ManutencaoVeiculo));
